export default "{\n    \"nextActionLabel\": \"Next\",\n    \"gotItActionLabel\": \"Got it!\",\n    \"ofLabel\": \" of \"\n}\n"